var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.724 6.641a.625.625 0 0 1 .814-.06l.07.06 5.391 5.391 5.392-5.39a.625.625 0 0 1 .813-.061l.07.06c.223.222.243.57.061.814l-.06.07-5.834 5.833a.625.625 0 0 1-.813.06l-.07-.06-5.834-5.833a.625.625 0 0 1 0-.884Z",
    fill: "#ADADAD"
  })));
};
export default SvgArrowDown;